import React from 'react'

export default function RegionsTable({regions, onEdit}) {
  return <table className='regions_table'>
    <thead>
      <tr>
        <th>Name</th>
        <th>Country</th>
        <th>State</th>
        <th>Total Locations</th>
        <th>Week View</th>
        <th>Referral Program</th>
        <th>Game Filters</th>
        <th>Enforce Stripe</th>
        <th>Currency</th>
        <th>Edit</th>
      </tr>
    </thead>
    <tbody>
      { 
        regions.map(region => {
          return <tr key={region.id}>
            <td>{region.name}</td>
            <td>{region.country}</td>
            <td>{region.state}</td>
            <td>{region.locations_count}</td>
            <td>{region.week_view.toString()}</td>
            <td>{region.referral_program_allowed.toString()}</td>
            <td>{region.game_filters.toString()}</td>
            <td>{region.enforce_stripe.toString()}</td>
            <td>{region.currency}</td>
            <td>
              <a className='btn btn-outline-default' onClick={() => onEdit(region)}>
                <i className='fa fa-cog'></i>
              </a>
            </td>
          </tr>
        })
      }
    </tbody>
  </table>
}
